import { startTransition, useEffect, useState } from "react"

export const useWindowScrolledMoreThan = (threshold: number) => {
  const [isCrossed, setIsCrossed] = useState(false)

  useEffect(() => {
    function updatePosition() {
      startTransition(() => {
        // to optimize performance it is wrapped in startTransition, if you don't know "startTransition" then don't touch this
        setIsCrossed(window.scrollY > threshold)
      })
    }

    window.addEventListener("scroll", updatePosition, { passive: true })
    updatePosition()

    return () => window.removeEventListener("scroll", updatePosition)
  }, [threshold])

  return isCrossed
}
